<template>
	<v-container class="evaluation">
		<v-layout row>
			<v-spacer></v-spacer>
			<v-btn @click="print" class="mr-3 no-print">Wydrukuj</v-btn>
		</v-layout>

		<v-card-title class="mt-3 mb-3">
			<div>
				<h2 class="mb-3">Ocena współpracy</h2>
				<div class="committee-collaboration-evaluation-card evaluation-font-size">
					<div>
						<strong class="mr-3">Nazwa konkursu:</strong> {{viewData.contestName}}
					</div>
					<div>
						<strong class="mr-3">Nazwa oferenta:</strong> {{viewData.bidderName}}
					</div>
				</div>
			</div>
		</v-card-title>

		<hr class="ma-4">

		<vue-form-generator
			name="generator"
			ref="vfg"
			:model="evaluationData.model"
			:options="formGenerator.formOptions"
			:schema="formGenerator.currentSchema"
			v-if="viewData.showGenerator">
		</vue-form-generator>

		<hr class="ma-4">

		<v-container class="text-xs-center no-print" style="display: block">
			<v-flex xs4>
				<egranty-number-input-field
					:disabled="readOnly"
					v-model="viewData.evaluation"
					placeholder="Od 0 do 5 z mnożnikiem 2"
					:validation-rules="[minMaxValidation]"
					label="Ocena">
				</egranty-number-input-field>
			</v-flex>
			<h3>Ocena ostateczna: {{ formatWithoutFixed(viewData.evaluation * 2) }}</h3>
		</v-container>
		<div class="print-only d-none ml-5 evaluation-font-size" style="page-break-inside: avoid">
			<div class="mt-3">Ocena (od 0 do 5 z mnożnikiem 2): <strong class="ml-3">{{viewData.evaluation}}</strong>
			</div>
			<div class="mt-2">Ocena ostateczna: <strong class="ml-3">{{ formatWithoutFixed(viewData.evaluation * 2)
			}}</strong></div>
		</div>

		<v-btn v-if="!readOnly" @click="viewData.saveEvaluationDialog = true" color="info" class="no-print">
			<v-icon class="mr-2 white--text">save</v-icon>
			Zapisz ocenę
		</v-btn>

		<evaluation-confirmation-dialog :action="save" :dialog-model="viewData.saveEvaluationDialog"
			@close-confirmation="viewData.saveEvaluationDialog = false"
			action-label="Zapisz" content="Czy na pewno chcesz zapisać ocenę?" header="Zapisanie oceny" icon="save"/>
	</v-container>
</template>

<script>
	import EvaluationConfirmationDialog from "../../EvaluationConfirmationDialog";
	import {genericFormUtil} from "@/utils/genericFormUtil";
	import {Api} from "@/api";
	import {CollaborationEvaluation} from "@/api/generated/CollaborationEvaluation";
	import egrantyNumberInputField from "../../../../../genericComponents/EgrantyNumberInputField";
	import {Numbers} from "@/utils/Numbers";
	import {Files} from "@/utils/Files";

	export default {
		name: "CommitteeCollaborationEvaluation",
		components: {EvaluationConfirmationDialog, egrantyNumberInputField},
		mixins: [Numbers],
		watch: {
			"evaluationData.model": {
				handler () {
					this.applyGenericForm(this.configuration.form);
				},
				deep: true
			}
		},

		props: {
			readOnly: {required: false, default: false}
		},

		data () {
			return {
				configuration: {
					form: "",
					disabled: false
				},

				evaluationData: {
					model: undefined
				},

				viewData: {
					showGenerator: false,
					bidderName: '',
					contestName: '',
					evaluation: '',
					saveEvaluationDialog: false
				},

				formGenerator: {
					currentSchema: {},
					currentModel: {},
					formOptions: {
						validateAfterLoad: false,
						validateAfterChanged: true,
						validateAsync: true,
					},
					currentConditionalHashes: []
				},
				minMaxValidation: function(value) {
					let temp = String(value).replace(",", ".");
					while(temp.indexOf(" ") > 0) {
						temp = temp.replace(" ", "");
					}
					temp = parseFloat(temp);
					if (temp <= 0 || temp > 5) {
						return "Ocena powinna mieć wartość od 0 do 5";
					}
					return true;
				}
			};
		},

		methods: {
			refresh () {
				this.loadData();
			},

			async loadData () {
				if (this.readOnly === true) {
					this.configuration.disabled = true;
				}
				await Api.syncGet(this, "/collaboration-evaluation/configuration?contestId=".concat(this.$route.params.id), successResponse => {
					this.configuration.form = genericFormUtil.decodeSchema(successResponse.schema);
					this.formGenerator.currentSchema = genericFormUtil.getSectionSchemaFromSchema(this.configuration.form, 0, this.configuration.disabled);
				});

				CollaborationEvaluation.get(this, this.$route.params.id, this.$route.params.bidderId, success => {
					this.viewData.bidderName = success.bidderName;
					this.viewData.contestName = success.contestName;
					this.viewData.evaluation = success.evaluation;
					if (success.filledForm === null) {
						this.evaluationData.model = genericFormUtil.buildModelFromSchema(this.configuration.form).sections[0].fields;
					} else {
						this.evaluationData.model = genericFormUtil.decodeSchema(success.filledForm);
					}
					this.applyGenericForm(this.configuration.form);
					this.viewData.showGenerator = true;
				});
			},

			async save () {
				let validationPromise = await this.$refs.vfg.validate();
				if (validationPromise.length > 0) {
					return;
				}
				this.$validator.validateAll().then((result) => {
					if (result) {
						evaluateCollaborator(this);
					} else {
						this.$messagesBus.$emit("error", "Uzupełnij poprawnie ocenę!");
					}
				});
			},

			async print () {
				await Files.methods.downloadFileAsBlob(
					this,
					Files.methods.getCommitteeEvaluationPrintUrl(
						this.$route.params.id,
						this.$route.params.bidderId),
					"ocena_współpracy.pdf");
			},

			prepareFormData () {
				return {
					filledForm: genericFormUtil.encodeSchema(this.evaluationData.model),
					evaluation: this.viewData.evaluation
				};
			},

			applyGenericForm (form) {
				let schema = genericFormUtil.getSectionSchemaFromSchema(form, 0, this.configuration.disabled);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					let schemaValues = this.evaluationData.model;
					this.formGenerator.currentSchema = genericFormUtil.filterSchemaByConditionalFieldsValue(schema, schemaValues);
					let indexes = genericFormUtil.calculateIndexes(schema);
					this.formGenerator.currentConditionalHashes = genericFormUtil.getConditionalValueHashes(schema, indexes);
				} else {
					this.formGenerator.currentSchema = schema;
				}
			}
		},

		created () {
			this.refresh();
		}
	};

	function evaluateCollaborator (ctx) {
		CollaborationEvaluation.postCollaboratorEvaluation(ctx,
			ctx.$route.params.id,
			ctx.$route.params.bidderId,
			ctx.prepareFormData(),
			successResponse => {
				ctx.$messagesBus.$emit("success", "Ocena została zapisana!", successResponse);
				ctx.$router.push("/app/contest/" + ctx.$route.params.id + "/bidders-evaluation");
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się zapisać oceny", errorResponse);
			});
	}

</script>

<style scoped>

</style>
